import {
  Button,
  Content,
  Dialog,
  DialogTrigger,
  Divider,
  Flex,
  Heading,
  TextField,
} from "@adobe/react-spectrum";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import Emitter from "../../../emitter";
import { API_CALLBACK_UPDATE } from "../../../constants/events";
import { makeCall } from "../../../utils/utils";
import { CALLBACK, VOICEMAIL } from "../../../constants/constants";
import storeRTK from "../../../store/storeRTK";
import { setConsultType } from "../../../actions/common";

interface CVDialPopoverPopoverProps {
  type: "voicemail" | "callback";
  number: string;
  handleNumberChange: (e: string) => void;
}

const CVDialPopover: React.FC<CVDialPopoverPopoverProps> = ({
  type,
  number,
  handleNumberChange,
}) => {
  const call = useSelector((state: RootState) => state.call);
  const state = useSelector((state: RootState) =>
    type === VOICEMAIL ? state.voicemail : state.callback
  );
  const isVoiceNetworkAvailable = useSelector(
    (state: RootState) => state.webrtc.isVoiceNetworkAvailable
  );
    const dialCallInProgress = useSelector(
      (state: RootState) => state.call.dialCallInProgress
    );

  const phoneNumber =
    type === VOICEMAIL
      ? state?.customer?.attributes?.CustomerANI ||
        state?.customer?.attributes?.PHONE_NUMBER
      : state?.customer?.attributes?.PHONE_NUMBER;

  const canEndCallback =
    type === CALLBACK
      ? !(
          state.customer?.attributes?.ALLOW_END_CALLBACK === false ||
          state.customer?.attributes?.ALLOW_END_CALLBACK === "false"
        ) && !call.id
      : true;

  const hangupCallHandler = () => {
    Emitter.emit(API_CALLBACK_UPDATE, {
      body: {
        participantId: state?.self?.id,
        conversationId: state?.id,
        state: "disconnected",
      },
    });
  };

  const handleCvDialCall = () => {
    storeRTK.dispatch(setConsultType(type));
    makeCall({
      number,
      dialCallInProgress,
    });
  };

  return (
    <Flex
      direction="row"
      alignItems="center"
      UNSAFE_className="call-action-items"
      gap="0.6rem"
    >
      <DialogTrigger
        type="popover"
        //@ts-ignore
        UNSAFE_className="callback-popover"
      >
        <Button
          UNSAFE_className="callback-call-dial-btn"
          variant="accent"
          isDisabled={!navigator.onLine || !isVoiceNetworkAvailable || call.id}
        >
          Dial Call
        </Button>
        <Dialog>
          <Heading level={4} UNSAFE_className="call-popover-heading">
            Make a call
          </Heading>
          <Divider />
          <Content>
            <Flex gap="0.5rem">
              <TextField
                defaultValue={phoneNumber}
                onChange={handleNumberChange}
              />
              <Button
                variant="accent"
                onPress={handleCvDialCall}
                UNSAFE_style={{
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                Continue
              </Button>
            </Flex>
          </Content>
        </Dialog>
      </DialogTrigger>
      <Button
        UNSAFE_className="callbackEndBtn"
        onPress={hangupCallHandler}
        variant="negative"
        isDisabled={!canEndCallback}
      >
        {type === VOICEMAIL ? "End Voicemail" : "End Callback"}
      </Button>
    </Flex>
  );
};

export default CVDialPopover;
